/* eslint no-underscore-dangle: ["error", { "allow": ["_meta"] }] */
import { React } from '@biletiniz/ui-core';
import { NextSeo, FAQPageJsonLd, BreadcrumbJsonLd } from '@biletiniz/seo';
import Head from 'next/head';
import { BusesHomePage } from '@biletiniz/web-app-containers';
import { busTicketFAQ, getCleanFaqJsonid } from '@biletiniz/web-app-utils';
import { useI18n } from '@biletiniz/intl';
import { useRouter, useHotBusBlogs } from '../src/hooks';

const BusesHomePages = ({ hotBusBlogs }) => {
  const { router } = useRouter();
  const i18n = useI18n();
  return (
    <>
      <NextSeo
        title="En Ucuz Otobüs Bileti Fiyatları, Bul ve Al - Biletiniz | Biletiniz.com"
        description="En uygun otobüs bileti fiyatlarını karşılaştırın! Kamil Koç, Metro, Pamukkale ve onlarca firmanın seferlerini sorgulayın, ucuz otobüs bileti alın."
        canonical={`https://biletiniz.com${
          router.locale !== 'tr' ? '/en' : ''
        }/otobus-bileti`}
      />
      <Head>
        <meta
          name="keywords"
          content="otobüs bileti, en ucuz otobüs bileti, otobüs bileti bul, otobüs bileti sorgulama, otobüs bileti fiyatları, otobüs bileti al"
        />
      </Head>
      <FAQPageJsonLd
        mainEntity={Object.values(
          busTicketFAQ[`${i18n.activeLocale}`] || {}
        ).map(item => ({
          questionName: getCleanFaqJsonid(item?.question),
          acceptedAnswerText: getCleanFaqJsonid(item?.answer),
        }))}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: i18n.t(`goToHome`),
            item: 'https://biletiniz.com/',
          },
          {
            position: 2,
            name: i18n.t(`busTicket`),
            item: 'https://biletiniz.com/otobus-bileti',
          },
        ]}
      />
      <BusesHomePage hotBusBlogs={hotBusBlogs} />
    </>
  );
};

export async function getStaticProps(context) {
  const { default: lngDict = {} } = await import(
    `@biletiniz/intl/locales/${context.locale}.json`
  );
  const data = await useHotBusBlogs();

  return {
    props: { lng: context.locale, lngDict, hotBusBlogs: data.hotBusBlogs },
  };
}

export default BusesHomePages;
